import './DividendsAndCapitalGains.scss';

import { array } from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';

import DividendsCapitalGainsTable from './DividendsCapitalGainsTable';
import {
  getIntradayPricing,
  getPreferencesDividendsAndCapitalGains
} from 'services/Rest';
import { getCombinedDividendsAndCapitalGainsData } from 'state/preferences/PreferencesSelectors';
import {
  getIntradayAccounts,
  getShareClassConversions
} from 'state/account/AccountSelectors';
import lockIcon from 'assets/icons/hex-lock-icon.svg';
import { AAMBeaconButton } from 'components/shared/Beacon';
import {
  getHasReceivedBrokerageData,
  getIsBrokerageDataError,
  getRequestStatus
} from 'state/requests/RequestStatusSelectors';
import { getRouter } from 'state/router/RouterSelectors';
import PageLoadingSpinner from 'components/layouts/Navigation/PageLoadingSpinner';
import { hasIntradayFail } from 'services/React-Utils';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';

const DividendsAndCapitalGains = ({
  tableData,
  sharedClassConversionFunds,
  hasBrokerageDataError,
  hasReceivedBrokerageData,
  requestStatus,
  intrdayAccounts
}) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasFailed, setHasFailed] = useState(false);
  useEffect(() => {
    getPreferencesDividendsAndCapitalGains();
    getIntradayPricing(true, false);
  }, []);

  useEffect(() => {
    setHasFailed(hasIntradayFail(intrdayAccounts));
  }, [intrdayAccounts]);

  useEffect(() => {
    if (
      requestStatus.intradayPricingManual === 'RECEIVED' ||
      requestStatus.intradayPricingManual === 'ERROR'
    ) {
      setShowSpinner(false);
      setHasLoaded(true);
    }

    if (requestStatus.intradayPricingManual === 'REQUESTED') {
      setShowSpinner(true);
    }
  }, [requestStatus]);

  if (hasBrokerageDataError || hasReceivedBrokerageData || hasLoaded) {
    return (
      <Fragment>
        <div className="dividends-and-capital-gains-header-v2 beacon-on-darker b-color-background--0 b-font-weight-bold b-typography-sans-serif--headline--600">
          Dividends & Capital Gains Distributions
        </div>
        <h2 className="dividends-and-capital-sub-header-v2 b-font-weight-bold b-typography-sans-serif--headline--400">
          My Accounts
        </h2>
        <div className="dividends-and-capital-gains-section-v2">
          {(hasBrokerageDataError || hasFailed) && (
            <div className="dividends-and-capital-gains-brokerage-refresh-container-v2">
              <div className="dividends-and-capital-gains-lock-icon-container-v2">
                <img src={lockIcon} alt="lock icon" />
                <div>
                  <p>
                    <strong>Data unable to load</strong>
                  </p>
                  <p className="dividends-and-capital-gain-paragraph">
                    Brokerage data could not be retrieved, please try again
                  </p>
                </div>
              </div>
              <div className="dividends-and-capital-gain-try-again-v2">
                {showSpinner ? (
                  <div className="loading-spinner dividends-and-capital-gain-try-again-loader-v2">
                    <Spinner />
                  </div>
                ) : (
                  <AAMBeaconButton
                    id={`update-cost-basis-button`}
                    variant="tertiary"
                    onBeaconEventClick={() => {
                      getIntradayPricing(false, false);
                    }}
                    disabled={showSpinner}
                  >
                    Try Again
                  </AAMBeaconButton>
                )}
              </div>
            </div>
          )}

          {hasBrokerageDataError ? (
            <ErrorPage />
          ) : (
            <DividendsCapitalGainsTable
              tableData={tableData}
              sharedClassConversionFunds={sharedClassConversionFunds}
            />
          )}
        </div>
      </Fragment>
    );
  } else {
    return <PageLoadingSpinner name={'Profile'} />;
  }
};

DividendsAndCapitalGains.propTypes = {
  tableData: array.isRequired,
  sharedClassConversionFunds: array
};

const mapStateToProps = (state) => ({
  tableData: getCombinedDividendsAndCapitalGainsData(state),
  sharedClassConversionFunds: getShareClassConversions(state),
  router: getRouter(state),
  hasBrokerageDataError: getIsBrokerageDataError(state),
  hasReceivedBrokerageData: getHasReceivedBrokerageData(state),
  requestStatus: getRequestStatus(state),
  intrdayAccounts: getIntradayAccounts(state)
});

export default connect(mapStateToProps)(DividendsAndCapitalGains);
